export const APIImobsaleUrl = 'https://api.torresdemeloneto.com.br/v1/venda/';
//export const APICadimo5Url = 'https://cadimo.imobsoft.com.br:8051/datasnap/rest/tsmSites/';
export const APICadimo5Url = 'https://cadimo.imobsoft.com.br:8052/';
export const TokenAPI = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IlRva2VuIEFQSSIsImJ1c2luZXNzIjoiVG9ycmVzIGRlIE1lbG8gTmV0byIsImlhdCI6MTUxNjIzOTAyMn0.MSx_rDRMztOYOSN3VVjg89YtxC5wtoGQHqGEUvFRcpU';
export const TokenCadimo5Api = btoa('torres:hpTy34Bfrlc9YGTqkeVJ');
export const TokenConta = 'hpTy34Bfrlc9YGTqkeVJ';
export const MODALIDADE_ALUGUEL = 'aluguel';
export const MODALIDADE_VENDA = 'venda';
export const METODOS = {
    "aluguel" : {
        'busca': 'BuscaImoveis',
        'tipos': 'CarregaTipos',
        'destaques': 'CarregaDestaques',
        'detalhes': 'CarregaDetalhes/',
        'destaquesEspeciais': 'CarregaDestaques',
        'caracteristicas': 'CarregaCaracteristicas',
        'caracteristicasCondominio': 'CarregaCaracteristicasCondominio',
        'buscaEndereco': 'CarregaBairrosCidades',
    },
    "venda" : {
        'busca': 'imoveis',
        'tipos': 'tiposImoveisOptions',
        'destaques': 'destaques',
        'detalhes': 'detalhes?codigo=',
        'destaquesEspeciais': 'destaqueEspecial',
        'caracteristicas': 'caracteristicasOptions',
        'caracteristicasCondominio': 'caracteristicasCondominioOptions',
        'buscaEndereco': 'buscaEndereco?palavra=',
    }
};